// FILE: client/src/components/ToastStack.js
import React from "react";

export default function ToastStack({ toasts = [], anchor = null }) {
  if (!toasts.length) return null;

  const wrap = anchor
    ? {
        ...wrapStyle,
        top: "auto",
        left: "auto",
        transform: "none",
        right: typeof anchor.right === "number" ? anchor.right : 18,
        bottom: typeof anchor.bottom === "number" ? anchor.bottom : 188,
        width: "min(420px, calc(100vw - 24px))",
        alignItems: "flex-end",
      }
    : wrapStyle;

  return (
    <div style={wrap}>
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            ...toastStyle,
            animation: "none",
          }}
        >
          <div style={leftStyle}>
            <span style={dotStyle} />
            <div style={textWrapStyle}>
              <div style={titleStyle}>{t.title || "Done"}</div>
              <div style={subStyle}>{t.text}</div>
            </div>
          </div>
        </div>
      ))}

      {/* Animations */}
      <style>{`
       @keyframes toastOut {
          from {
            opacity: 1;
            transform: translate(-50%, 0px);
          }
          to {
            opacity: 0;
            transform: translate(-50%, -12px);
          }
        }
      `}</style>
    </div>
  );
}

/* ---------- Styles ---------- */

const wrapStyle = {
  position: "fixed",
  inset: "auto 0 auto 0",
  top: "calc(env(safe-area-inset-top) + 72px)",
  left: 0,
  right: 0,
  margin: "0 auto",
  zIndex: 999999,
  display: "flex",
  flexDirection: "column",
  gap: 10,
  pointerEvents: "none",
  width: "min(520px, calc(100vw - 24px))",
};

const toastStyle = {
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  padding: "12px 14px",
  borderRadius: 14,

  /* Gloss green glass */
  background:
    "linear-gradient(135deg, rgba(20, 210, 190, 0.28), rgba(80, 130, 255, 0.16))," +
    "linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.02))",

  border: "1px solid rgba(255,255,255,0.22)",
  boxShadow:
    "0 0 0 1px rgba(255,255,255,0.10), 0 18px 55px rgba(0,0,0,0.55)",

  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",

  color: "rgba(255,255,255,0.92)",
};

const leftStyle = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  minWidth: 0,
};

const dotStyle = {
  width: 10,
  height: 10,
  borderRadius: 999,
  background: "rgba(60, 255, 210, 0.9)",
  boxShadow:
    "0 0 0 3px rgba(60,255,210,0.18), 0 0 18px rgba(60,255,210,0.28)",
  flex: "0 0 auto",
};

const textWrapStyle = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  lineHeight: 1.1,
};

const titleStyle = {
  fontWeight: 900,
  fontSize: 14,
};

const subStyle = {
  marginTop: 2,
  fontSize: 12,
  color: "rgba(255,255,255,0.82)",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
